import { ScenarioType } from '@account/consents-shared-lib'
import { GlCheckbox, GlCheckboxProps } from '@adl/component-checkbox'
import { GlLink } from '@adl/component-link'
import { GlTooltip } from '@adl/component-tooltip'
import { useConfig } from '@crystal/config'
import { Translations, useTranslations } from '@crystal/translator'
import { FC, useEffect, useState } from 'react'

import { AccountPortalConfig } from '../config'
import { getProdRedirectUrl } from '../utils'

import styles from './account-portal.module.scss'

type MinAgeConfirmationProps = {
  scenarioType: ScenarioType
} & GlCheckboxProps

const AgeCheckBoxLabel = () => {
  const t = useTranslations<Translations>()
  const { brand, locale, legalPolicy, env } = useConfig<AccountPortalConfig>()
  const minAge = t('landing.market.min.age')
  const prodRedirectUrl = getProdRedirectUrl(
    legalPolicy?.helpPagesUrls?.termsAndConditions ?? '/terms_and_conditions',
    brand,
    locale,
    env,
  )

  return (
    <>
      <p className={styles['right-space']}>{t('landing.min.age.checkbox.label', minAge)}</p>
      <GlTooltip size="small" label={t('landing.ageConfirmation.whyDoesItMatter')} placement="right">
        <p>{t('landing.age.legal.copy', 'landing.termsconditions')}</p>
        <GlLink href={prodRedirectUrl} className="gl-link" target="_blank">
          {t('landing.termsconditions')}
        </GlLink>
      </GlTooltip>
    </>
  )
}

export const AgeConfirmationCheckBox: FC<MinAgeConfirmationProps> = props => {
  const [isAgeChecked, setIsAgeChecked] = useState<boolean>(false)

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsAgeChecked(event.target.checked)
    props.onChange && props.onChange(event)
  }

  useEffect(() => {
    if (!props.onChange) {
      return
    }

    // notify the initial value
    props.onChange({
      target: {
        type: 'checkbox',
        name: props.name,
        checked: isAgeChecked,
      },
    } as React.ChangeEvent<HTMLInputElement>)
  }, [])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id: _, ...restProps } = props

  return (
    <div className="gl-vspace-bpall-small" data-auto-id="age-check-box">
      <GlCheckbox {...restProps} isChecked={isAgeChecked} onChange={onChange} label={<AgeCheckBoxLabel />} />
    </div>
  )
}
